module.exports = __webpack_public_path__ + "assets/images/party-popper-emoji_db5ad2328d447ecdb66c54e7e5551e99.png";